export default {
    MODAL_OPEN: 'MODAL_OPEN',
    MODAL_CLOSE: 'MODAL_CLOSE',

    AJAX_STARTED: 'AJAX_STARTED',
    AJAX_FINISHED: 'AJAX_FINISHED',

    CATEGORIES_FETCH: 'CATEGORIES_FETCH',
    CATEGORIES_RECEIVED: 'CATEGORIES_RECEIVED',

    CATEGORY_FETCH: 'CATEGORY_FETCH',
    CATEGORY_RECEIVED: 'CATEGORY_RECEIVED',

    VIDEOS_FETCH: 'VIDEOS_FETCH',
    VIDEOS_RECEIVED: 'VIDEOS_RECEIVED',

    VIDEO_FETCH: 'VIDEO_FETCH',
    VIDEO_RECEIVED: 'VIDEO_RECEIVED',
    VIDEO_VIEW: 'VIDEO_VIEW',

    MODELS_FETCH: 'MODELS_FETCH',
    MODELS_RECEIVED: 'MODELS_RECEIVED',

    MODEL_FETCH: 'MODEL_FETCH',
    MODEL_RECEIVED: 'MODEL_RECEIVED',
    MODEL_RATED: 'MODEL_RATED',

    SEARCH_FETCH: 'SEARCH_FETCH',
    SEARCH_RECEIVED: 'SEARCH_RECEIVED',

    MOBILE_MENU_OPEN: 'MOBILE_MENU_OPEN',
    MOBILE_MENU_CLOSE: 'MOBILE_MENU_CLOSE',

    RELATED_SEARCHED_RECEIVED: 'RELATED_SEARCHED_RECEIVED'
}



// WEBPACK FOOTER //
// redux/actionTypes.js